import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import HBCloseButton from '../HBCloseButton/HBCloseButton';
import { useModalInternalContext } from './ModalInternalContext';

interface Props {
    theme?: 'light' | 'dark';
}

const HBModalCloseButton = ({ theme = 'dark' }: Props) => {
    const { getTestIdProps } = useModalInternalContext();

    return (
        <Dialog.Close asChild>
            <HBCloseButton
                size="sm"
                theme={theme}
                distance={12}
                onClick={null}
                {...getTestIdProps('close')}
            />
        </Dialog.Close>
    );
};

export default HBModalCloseButton;
